import React from "react";
import PropTypes from "prop-types";
import {
    Card,
    CardBody,
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Button,
    Spinner
} from "reactstrap";

/**
 * Generate Links Form Component
 * Form for generating coupon scanner links with domain, handle, and query fields
 */
const GenerateLinksForm = React.memo(({
    domain,
    handle,
    query,
    loading,
    onSubmit,
    onInputChange
}) => {
    return (
        <Card>
            <CardBody>
                <Form onSubmit={onSubmit}>
                    <FormGroup className="row mb-4 justify-content-center">
                        <Label
                            htmlFor="horizontal-name-Input"
                            className="col-sm-1 col-form-label text-right"
                        >
                            Domain <span className="text-danger">*</span>
                        </Label>
                        <Col sm={3}>
                            <Input
                                type="text"
                                name="domain"
                                placeholder="Domain (e.g. example.com)"
                                className="form-control"
                                id="horizontal-name-Input"
                                onChange={onInputChange}
                                value={domain || ''}
                                required
                                disabled={loading}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup className="row mb-4 justify-content-center">
                        <Label
                            htmlFor="horizontal-handle-Input"
                            className="col-sm-1 col-form-label text-right"
                        >
                            Handle <span className="text-danger">*</span>
                        </Label>
                        <Col sm={3}>
                            <Input
                                type="text"
                                name="handle"
                                placeholder="Handle (e.g. example)"
                                className="form-control"
                                id="horizontal-icon-Input"
                                onChange={onInputChange}
                                value={handle || ''}
                                required
                                disabled={loading}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup className="row mb-4 justify-content-center">
                        <Label
                            htmlFor="horizontal-email-Input"
                            className="col-sm-1 col-form-label text-right"
                        >
                            Query <span className="text-danger">*</span>
                        </Label>
                        <Col sm={3}>
                            <Input
                                type="text"
                                name="query"
                                placeholder="Query"
                                className="form-control"
                                id="horizontal-query-Input"
                                value={query || ''}
                                onChange={onInputChange}
                                required
                                disabled={loading}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup className="row justify-content-center">
                        <Col sm={2}>
                            <div>
                                <Button
                                    type="submit"
                                    color="primary"
                                    className="w-md"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <Spinner color="light" size="sm" className="me-2" />
                                            Generating...
                                        </>
                                    ) : (
                                        'Generate Links'
                                    )}
                                </Button>
                            </div>
                        </Col>
                    </FormGroup>
                </Form>
            </CardBody>
        </Card>
    );
});

GenerateLinksForm.propTypes = {
    domain: PropTypes.string,
    handle: PropTypes.string,
    query: PropTypes.string,
    loading: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
};

GenerateLinksForm.displayName = 'GenerateLinksForm';

export default GenerateLinksForm;

